




























# Lib autocomplete https://github.com/paliari/v-autocomplete
listItem = require './tag_item.vue'
helpers = require '../../../helpers.coffee'
on_clickaway = require('vue-clickaway')

view_model = {
  mixins: [ on_clickaway.mixin ]

  props:
    tag_created:
      default: -> null

    show_change_tags:
      default: -> false

    filters:
      default: -> {}

    unselected_ids:
      default: -> []

    selected_ids:
      default: -> []

  data : ->
    loading: false
    show: true
    current_company: Session.current_company
    current_user: Session.current_user
    tag: null
    tags: []
    tags_all: []
    tags_base: []
    show_tags: true
    template: listItem
    change_tags: []
    show_button_apply: false
    autocomplete_text: ''
    attrs: {
      placeholder: @$t('contacts.label.searchTags')
    }

  computed:
    button_title_create_tag: ->
      'Criar tag '+'"'+@autocomplete_text+'"'

  methods:
    setFocus: ->
      jQuery('#'+@id+'.v-autocomplete .v-autocomplete-input').focus()

    tagIndex: ->
      new TagsResource().index(@loadTagsSuccess, null, params: { q: { company_id_eq: @current_company.id } })

    openModal: ->
      EventsBus.$emit 'confirm-modal-show', { id: 'create-tag', name: @autocomplete_text }

    filterTags: (text) ->
      @autocomplete_text = text
      return(@tags = @tags_all) if text == ''

      @tags = []
      regex = new RegExp(text, 'i')
      for tag in @tags_all when regex.exec(tag.name)
        @tags.push(tag)

    loadTagsSuccess: (data) ->
      for tag in data.tags
        tag.behavior = 'uncheck'
        @tags.push(tag)

      @tags_all = @tags

    itemClicked: (tag) ->
      @circleBehavior(tag)
      @updateChangeTags(tag)
      @show_button_apply = @toogleShowButtonApply(tag)

    circleBehavior: (tag) ->
      if tag.behavior == 'check'
        tag.behavior = 'uncheck'
      else if tag.behavior == 'uncheck'
        has_tag = @tags_base.find (t)-> tag.id == t.id && t.behavior == 'line'
        tag.behavior = if has_tag? then 'line' else 'check'
      else
        tag.behavior = 'check'

    updateChangeTags: (tag) ->
      change_tags = @change_tags.find (t)-> tag.id == t.id
      change_tags.behavior = tag.behavior if change_tags

    toogleShowButtonApply: (tag) ->
      tag_base = @tags_base.find (t)-> tag.id == t.id
      tag_base && tag.behavior != tag_base.behavior

    changeTagsParams: ->
      type: 'change_tags'
      filters: @filters
      change_tags: @change_tags
      selected_ids: @selected_ids
      unselected_ids: @unselected_ids

    callExecuteChangeTags: ->
      Loader.on()
      params = @changeTagsParams()
      @contact_resource.massActionExecute @executeSuccess, @executeError, params

    executeSuccess: (response) ->
      Loader.off()
      data =
        contact_ids: response.body.contact_ids
        change_tags: @change_tags

      EventsBus.$emit 'MassActions:Tags:UpdateContacts', data
      alertify.success "Tags modificadas com sucesso."

    executeError: () ->
      Loader.off()
      if @current_user.isSeller()
        alertify.error "Por favor, selecione somente contatos de sua responsabilidade."
      else
        alertify.error "Ops, algo deu errado."

    callPrepareChangeTags: ->
      @loading = true
      params = @changeTagsParams()
      @contact_resource.massActionPrepare @prepareSuccess, @unknownError, params

    prepareSuccess: (response) ->
      response_tags = response.body?.tags || []

      for tag in @tags
        response_tag = response_tags.find (t)-> tag.id == t.id
        tag.behavior = response_tag?.behavior || 'uncheck'

        @tags_base.push({ id: tag.id, behavior: tag.behavior })
        @change_tags.push({ id: tag.id, name: tag.name, color: tag.color, behavior: tag.behavior })

        # Checking new tag created
        @itemClicked(tag) if @tag_created && @tag_created.id == tag.id

      @loading = false

    resetTags: ->
      @autocomplete_text = ''
      @tags = []
      @tag  = ''

    tagCreated: (data) ->
      @resetTags()
      @tagIndex()

    showChangeTags: ->
      @show_button_apply = false

      if @show_change_tags
        @callPrepareChangeTags()
        @setFocus()
      else
        @change_tags = []
        @tags_base   = []

  created: ->
    @tagIndex()
    @id = 'mass-action-tags'
    @contact_resource = new ContactsResource Session.current_company.id
    @showChangeTags()
    EventsBus.$on 'MassActions:Autocomplete:ItemClicked', @itemClicked

  beforeDestroy: ->
    EventsBus.$off 'MassActions:Autocomplete:ItemClicked', @itemClicked

}
exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/autocomplete/tags.vue